import { GetUseOfForceIncidentsForServiceProviderUnitResponse, UseOfForceIncidentModel } from '../../api-service/clients';
import { moduleClientFactory } from '../../api-service/module-client-factory';

const useOfForceClient = moduleClientFactory.createServiceProviderUnitUseOfForceClient();

export function getUseOfForceUnitOverview(serviceProviderUnitId: string): Promise<GetUseOfForceIncidentsForServiceProviderUnitResponse> {
  return useOfForceClient.getUseOfForceIncidentsForServiceProviderUnit({ serviceProviderUnitId });
}

const citizenUseOfForceClient = moduleClientFactory.createCitizenServiceProviderUseOfForceClient();

export async function registerUseOfForceRelativesInformation(
  citizenId: string,
  serviceProviderUnitId: string,
  incidentId: string,
  informedOn: string | undefined,
  notInformed: boolean
): Promise<UseOfForceIncidentModel> {
  const response = await citizenUseOfForceClient.registerUseOfForceRelativesInformation({
    citizenId,
    serviceProviderUnitId,
    incidentId,
    informedOn,
    notInformed,
  });
  return response.incident;
}

export async function registerUseOfForceResponsibleMunicipalitySending(
  citizenId: string,
  serviceProviderUnitId: string,
  incidentId: string,
  sentAt: Date
): Promise<UseOfForceIncidentModel> {
  const response = await citizenUseOfForceClient.registerUseOfForceResponsibleMunicipalitySending({
    citizenId,
    serviceProviderUnitId,
    incidentId,
    sentAt,
  });
  return response.incident;
}
